import { Component, Input, OnInit } from '@angular/core';
import { UrlHelper } from '../../helper/url.helper';
import { environment } from '../../../environments/environment';
import { Locale } from '../../model/Locale';
import { TenantService } from '../../service/tenant.service';

@Component({
  selector: 'language-switch',
  templateUrl: './language-switch.component.html',
  styleUrls: ['./language-switch.component.scss']
})
export class LanguageSwitchComponent implements OnInit {

  public static readonly MANUAL_LOCALE_PARAM = 'manual_locale';

  @Input() theme: 'dark' | 'light' = 'light';
  @Input() localeOverride = false;

  constructor() {
  }

  ngOnInit(): void {
  }

  switchLanguage(language: string) {
    LanguageSwitchComponent.switchLanguage(language, this.localeOverride);
  }

  public static switchLanguage(language: string, addOverride: boolean = false) {
    const langUrl = language == Locale.uk ? UrlHelper.DEFAULT_UK_PATH : UrlHelper.DEFAULT_EN_PATH;

    const path = window.location.pathname + window.location.search;
    const domainPrefix = TenantService.getSubdomain();

    let url = `https://${domainPrefix ? domainPrefix + '.' : ''}${environment.ui.host}${langUrl}/${path.substr(3)}`;

    if (addOverride && !url.includes(LanguageSwitchComponent.MANUAL_LOCALE_PARAM)) {
      if (url.includes('?')) {
        url = url + `&${LanguageSwitchComponent.MANUAL_LOCALE_PARAM}=true`;
      } else {
        url = url + `?${LanguageSwitchComponent.MANUAL_LOCALE_PARAM}=true`;
      }
    }

    window.open(url, '_self');
  }
}
